import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // <-- Import CommonModule here
import { Navbar } from './navbar';
// import { ChildScene } from "./land copy";
import { Wwww } from "./land3d";
// import { MultiTrackAudioPlayerComponent } from "./audio";
import { isAuth } from './auth';

@Component({
  selector: 'app-inicio',
  standalone: true,
  imports: [
    CommonModule, // <-- Include CommonModule in the imports array
    Navbar, 
    // ChildScene, 
    Wwww, 
    // MultiTrackAudioPlayerComponent, 
  ],
  template: `
    <app-navbar></app-navbar>
    <app-www></app-www>
  `
})
export class Inicio {
  auth: any = isAuth();
}